export const ka = {
  title: 'ხის საფარი',
  subtitle: '2000/2010, Hansen/UMD/Google/USGS/NASA',
  download_data: 'https://glad.umd.edu/dataset/global-2010-tree-cover-30-m',
  learn_more: 'http://science.sciencemag.org/content/342/6160/850',
  content: [
    {
      label: 'ფუნქცია',
      value: 'განსაზღვრავს ხის საფარის ტერიტორიებს',
    },
    {
      label: 'რეზოლუცია',
      value: '30 × 30 მეტრი',
    },
    {
      label: 'გეოგრაფიული გაშუქება',
      value: 'გლობალური მიწა (ანტარქტიდისა და არქტიკული კუნძულების გამოკლებით)',
    },
    {
      label: 'წყარო',
      value:
        'ჰანსენი, მ. C., P. V. Potapov, R. Moore, M. Hancher, S. A. Turubanova, A. Tyukavina, D. Thau, S. V. Stehman, S. J. Goetz, T. R. Loveland, A. Kommareddy, A. Egorov, L. Chini, C. O. Justice, და J. R. G. Townshend. 2013. "21-ე საუკუნის ტყის საფარის ცვლილების მაღალი რეზოლუციის გლობალური რუკები". მეცნიერება 342 (15 ნოემბერი): 850–53. მონაცემები ხელმისაწვდომია: https://glad.umd.edu/dataset/global-2010-tree-cover-30-m.',
    },
    {
      label: 'სიხშირე',
      value: '',
    },
    {
      label: 'შინაარსის თარიღი',
      value: '2000 & 2010',
    },
    {
      label: 'გაფრთხილება',
      value:
        'ამ კვლევის მიზნით, "ხის საფარი" განისაზღვრა, როგორც ყველა მცენარეულობა 5 მეტრზე მეტი სიმაღლით. "ხის საფარი" არის ხეების ბიოფიზიკური ყოფნა და შეიძლება მიიღოს ბუნებრივი ტყეების ან პლანტაციების ფორმა, რომელიც არსებობს მთელ რიგ კანოპის სიმკვრივეზე.',
    },
    {
      label: 'ლიცენზია',
      value: 'CC 4.0-ით',
    },
  ],
  overview: {
    label: 'მიმოხილვა',
    value:
      'ეს მონაცემთა ნაკრები, თანამშრომლობა GLAD (გლობალური მიწის ანალიზისა და აღმოჩენის) ლაბორატორიას შორის მერილენდის უნივერსიტეტში, Google, USGS და NASA, აჩვენებს ხის საფარს მთელ გლობალურ მიწაზე (გარდა ანტარქტიდისა და მრავალი არქტიკული კუნძულისა) 2000 და 2010 წლებში 30 × 30 მეტრიანი რეზოლუციისთვის. "პროცენტის ხის საფარი" განისაზღვრება, როგორც მიწის ზედაპირის ხის ტილოების დაფარვის სიმკვრივე და ფერადი კოდირებულია სიმკვრივის ფრჩხილით (იხ. ლეგენდა).\n\nამ ფენის მონაცემები წარმოიქმნა მრავალსპექტრული სატელიტური გამოსახულების გამოყენებით Landsat 7 თემატური რუქის პლუს (ETM+) სენსორიდან. 600,000-ზე მეტი სურათის მკაფიო ზედაპირული დაკვირვება გაანალიზდა Google Earth Engine- ის გამოყენებით, დედამიწის დაკვირვებისა და მონაცემთა ანალიზის ღრუბლოვანი პლატფორმის გამოყენებით, რათა დადგინდეს პიქსელის ხის საფარი ზედამხედველობის ქვეშ მყოფი სწავლის ალგორითმის გამოყენებით.\n\nნაჩვენები მონაცემების ხის საფარის ტილო სიმკვრივე განსხვავდება შერჩევის მიხედვით - გამოიყენეთ ლეგენდა რუკაზე, რათა შეცვალოთ მინიმალური ხის საფარის ტილოების სიმკვრივის ბარიერი.',
  },
  citation: {
    label: 'ციტატა',
    value:
      'Use the following credit when these data are displayed:\nSource: Hansen/UMD/Google/USGS/NASA, accessed through Global Forest Watch\n\nUse the following credit when these data are cited:\nHansen, M. C., P. V. Potapov, R. Moore, M. Hancher, S. A. Turubanova, A. Tyukavina, D. Thau, S. V. Stehman, S. J. Goetz, T. R. Loveland, A. Kommareddy, A. Egorov, L. Chini, C. O. Justice, and J. R. G. Townshend. 2013. “High-Resolution Global Maps of 21st-Century Forest Cover Change.” Science 342 (15 November): 850–53. Data available on-line from:https://glad.umd.edu/dataset/global-2010-tree-cover-30-m. Accessed through Global Forest Watch on 11/02/2025. www.globalforestwatch.org',
  },
};
